import i18n from '../services/i18n';

export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const required = value => value != null ? undefined : i18n.t('Required');

export const mustBeNumber = value =>
  value && isNaN(value) ? i18n.t('Must be a number') : undefined;

export const mustBeInteger = value => {
  return value && !Number.isInteger(Number(value)) ? i18n.t('Must be a integer') : undefined;
};

export const mustBePositive = value => {
  return value && Number(value) <= 0 ? i18n.t('Must be positive') : undefined;
};

export const mustNotBeNegative = value => {
  return value && Number(value) < 0 ? i18n.t('Must be not negative') : undefined;
};

export const phoneNumberFormat = value => {
  const PhoneRegex = /^(0|\+98)?([ ]|-|[()]){0,2}9[1|2|3|4|9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}$/;
  if(value  && value.length < 10 && !PhoneRegex.test(value)){
    return i18n.t('Invalid phone number format');
  }
  return undefined;
};

export const emailFormat = value => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return value && !emailRegex.test(value) ? i18n.t('Invalid email format') : undefined;
};

export const length = len => value =>
  !value || value.length === len ? undefined : i18n.t('Length must be {{len}}.', {len});

export const maxLength = max => value =>
  !value || value.length <= max
    ? undefined
    : i18n.t('Length must be less than {{max}}', {max});
